// extracted by mini-css-extract-plugin
module.exports = {"block":"TypeBlock-module__block___3GTIJ","active":"TypeBlock-module__active___2tiUF"};